<template>
  <div class="main" v-loading="loading">
    <div class="gong_neng">
      <el-button @click="goPage">返回</el-button>
    </div>
    <div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        @cell-click="cellClick"
      >
        <el-table-column
          prop="city_name"
          label="代理商城市"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="city_radar_count"
          label="线索数量"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
// import { delete } from "vue/types/umd";

export default {
  data() {
    return {
      tableData: [],
      loading: true,
    };
  },
  created() {
    this.list();
  },

  methods: {
    cellClick(row) {
      console.log(row);
      if (row.city_radar_count != 0) {
        this.$router.push({ path: "/rader_C", query: { src: row.city_name } });
      } else {
        this.$message.error("该城市线索为空");
      }
    },

    goPage() {
      this.$router.go(-1);
    },
    list() {
      let obj = {};
      let url = "/hr24_index_data/v1/province_radar_data/";
      require("post", url, obj).then((res) => {
        if (!res.code) {
          console.log(res);
          this.tableData = res.data;
          this.loading = false;
          // this.title = res.data.title
        } else {
        }
      });
    },
  },
};
</script>

<style scoped>
.main {
  margin-top: 46px;
  margin-left: 229px;
  background: #ffff;
  min-height: 70vh;
  margin-bottom: 20px;
  width: 80vw;

  border-radius: 4px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  padding: 50px;
}
.gong_neng {
  padding: 12px 0;
}
.page {
  padding: 12px 0;
}
</style>



// WEBPACK FOOTER //
// src/index/rader_agent_S.vue